import { render, staticRenderFns } from "./ServiceDetailsComponent.vue?vue&type=template&id=045aa8ef&scoped=true&"
import script from "./ServiceDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045aa8ef",
  null
  
)

export default component.exports